import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { OperationDetailsEditLocationSelectPage } from './operation-details-edit-location-select';
import { OperationDetailsLocationSelectPageModule } from '../operation-details-location-select/operation-details-location-select.module';
import { PipesModule } from '../../../pipes/pipes.module';
import { TextMaskModule } from 'angular2-text-mask';
import { FoundationModule } from '../../../_foundation/foundation.module';
import { SharedModule } from '../../shared/shared.module';
import { DirectivesModule } from '../../../directives/directives.module';
import { IonicSelectableModule } from 'ionic-selectable';

@NgModule({
  declarations: [
    OperationDetailsEditLocationSelectPage,
  ],
    imports: [
        IonicPageModule.forChild(OperationDetailsEditLocationSelectPage),
        OperationDetailsLocationSelectPageModule,
        PipesModule,
        TextMaskModule,
        FoundationModule,
        SharedModule,
        DirectivesModule,
        IonicSelectableModule,
    ],
})
export class OperationDetailsEditLocationSelectPageModule {
}



// WEBPACK FOOTER //
// ./src/pages/operations/operation-details-edit-location-select/operation-details-edit-location-select.module.ts